import { z } from 'zod'

export const ADMINDESKTOPAGENTSGET_CONTRACT_VERSION = '1.0.0' as const
export const adminDesktopAgentsGetResponseSchema = z.unknown()
export type AdminDesktopAgentsGetResponse = z.infer<typeof adminDesktopAgentsGetResponseSchema>
